import { CompanyEntry } from '@dreryk/egabinet-invoice-frontend-api';

import { FormContextValues } from '@dreryk/react-common';

import { InvoiceCreateFormRegisterControllerProp } from '../InvoiceCreateForm.types';
import { InvoiceCreateFormAddressSectionBeanPart } from '../addressSection/InvoiceCreateFormAddressSection.types';

import { InvoiceCreateFormCompanyIdentificationDetailsFormBeanPart } from './InvoiceCreateFormCompanyIdentificationDetails.types';
import { InvoiceCreateFormCompanyNameFormBeanPart } from './InvoiceCreateFormCompanyName.types';
import { companyNameVisitor } from './InvoiceCreateFormCompanyName.utils';
import { InvoiceCreateFormCompanyNameSelect } from './InvoiceCreateFormCompanyNameSelect';
import { InvoiceCreateFormCompanyNameTextInput } from './InvoiceCreateFormCompanyNameTextInput';

type InvoiceCreateFormCompanyNameProps = InvoiceCreateFormRegisterControllerProp &
   InvoiceCreateFormCompanyNameFormBeanPart &
   Pick<
      FormContextValues<
         InvoiceCreateFormCompanyIdentificationDetailsFormBeanPart & InvoiceCreateFormAddressSectionBeanPart
      >,
      'getValues' | 'reset'
   > & {
      companyEntries: CompanyEntry[] | undefined;
   };

export const InvoiceCreateFormCompanyName = (props: InvoiceCreateFormCompanyNameProps): JSX.Element => {
   const { companyEntries, companyName, getValues, register, reset } = props;

   return companyNameVisitor({ companyName: companyName, companyEntries: companyEntries })({
      visitCompanyEntries: (companyEntry) => (
         <InvoiceCreateFormCompanyNameSelect
            companyEntries={companyEntry}
            getValues={getValues}
            register={register}
            reset={reset}
         />
      ),
      visitCompanyName: () => <InvoiceCreateFormCompanyNameTextInput register={register} />,
   });
};
